(function(angular, module) {var InfiniteScrollController, infiniteScrollDirective,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

InfiniteScrollController = (function() {

  /* @ngInject */
  function InfiniteScrollController($q, $scope, $element, Page) {
    this.triggerEvent = bind(this.triggerEvent, this);
    this.scrollHandler = bind(this.scrollHandler, this);
    this.disableScrollEvent = bind(this.disableScrollEvent, this);
    this.enableScrollEvent = bind(this.enableScrollEvent, this);
    this.atBottom = bind(this.atBottom, this);
    this.q = arguments[0], this.scope = arguments[1], this.element = arguments[2];
    this.scrollContainer = Page.element();
    this.enableScrollEvent();
    this.scope.$on('$destroy', this.disableScrollEvent);
  }

  InfiniteScrollController.prototype.atBottom = function() {
    var elementRect, scrollRect;
    scrollRect = this.scrollContainer[0].getBoundingClientRect();
    elementRect = this.element[0].getBoundingClientRect();
    return elementRect.bottom <= scrollRect.height;
  };

  InfiniteScrollController.prototype.enableScrollEvent = function() {
    this.scrollContainer.on('scroll', this.scrollHandler);
  };

  InfiniteScrollController.prototype.disableScrollEvent = function() {
    this.scrollContainer.off('scroll', this.scrollHandler);
  };

  InfiniteScrollController.prototype.scrollHandler = function() {
    if (!this.atBottom() || !this.hasMore || this.waiting) {
      return;
    }
    this.waiting = true;
    this.scope.$applyAsync(this.triggerEvent);
  };

  InfiniteScrollController.prototype.triggerEvent = function() {
    var result;
    this.waiting = true;
    result = this.doScroll();
    return this.q.when(result).then((function(_this) {
      return function() {
        _this.waiting = false;
      };
    })(this));
  };

  return InfiniteScrollController;

})();

infiniteScrollDirective = function() {
  'ngInject';
  return {
    restrict: 'A',
    scope: {
      doScroll: '&infiniteScroll',
      hasMore: '='
    },
    controllerAs: 'ctrl',
    controller: InfiniteScrollController,
    bindToController: true
  };
};

module.directive('infiniteScroll', infiniteScrollDirective);
})(angular, angular.module("dyb.util"));